import React, { useEffect } from "react"

import { badges, darkTheme, alignCenter } from "./trustBadges.module.css"

import SslSecure from "assets/ssl-badge.svg"

const TrustBadges = ({ dark, center }) => {
  useEffect(() => {
    const hasScript = document.getElementById("ra-embed-verified-seal")

    if (!hasScript) {
      const script = document.createElement("script")
      script.src = "https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js"
      script.dataset.id = "QTIwUi04VWJLbnVpazlQaDpmYWNpby1wYWdhbWVudG9z"
      script.dataset.target = "ra-verified-seal"
      script.dataset.model = "2"
      script.id = "ra-embed-verified-seal"
      document.body.appendChild(script)
    }
  }, [])

  return (
    <div className={[badges, dark && darkTheme, center && alignCenter].filter(Boolean).join(" ")}>
      <SslSecure alt="Verificado: SSL Seguro" />
      <div id="ra-verified-seal" style={{ borderRadius: "4px", overflow: "hidden" }}></div>
    </div>
  )
}

export default TrustBadges
